import * as React from "react";
import { useNotification } from "../../context/notification-provider";
import { useDialogs } from "../dialog/use-dialog";
import { JunkValue } from "./types";
import { deleteJunkValue } from "./service";

const JunkValueDelete = ({
  selectedJunkValue,
  open,
  onClose,
}: {
  selectedJunkValue: JunkValue;
  open: boolean;
  onClose: () => void;
}) => {
  const { showNotification } = useNotification();
  const { confirm } = useDialogs();

  const hasOpenedRef = React.useRef(false);

  React.useEffect(() => {
    if (!open || hasOpenedRef.current) return;

    hasOpenedRef.current = true;

    const run = async () => {
      try {
        const result = await confirm(
          <div>
            Are you sure you want to delete <b>{selectedJunkValue.value}</b>?
            This action cannot be undone.
          </div>,
          {
            title: "Confirm Junk Value Deletion",
            okText: "Delete",
            cancelText: "Cancel",
            severity: "error",
          },
        );

        if (result === true) {
          try {
            await deleteJunkValue(selectedJunkValue);
            showNotification({
              message: "Junk value deleted successfully.",
              severity: "success",
              duration: 3000,
            });
          } catch (err) {
            showNotification({
              message: `Failed to delete junk value. Reason: ${(err as Error).message}`,
              severity: "error",
              duration: 3000,
            });
          }
        }
      } catch {
        showNotification({
          message: "Failed to show confirmation dialog.",
          severity: "error",
          duration: 3000,
        });
      } finally {
        onClose();
        hasOpenedRef.current = false;
      }
    };

    run();
  }, [
    open,
    confirm,
    showNotification,
    onClose,
    selectedJunkValue.value,
    selectedJunkValue.id,
    selectedJunkValue,
  ]);

  return null;
};

export default JunkValueDelete;
